import React from 'react'
import { Carousel, type CarouselImage } from '#app/components/ui/carousel.tsx'
import { Tag } from '#app/components/ui/tag.tsx'

export default function AboutUsSection() {
	const carouselImages: CarouselImage[] = [
		{
			src: '/img/proposito/proposito1.png',
			alt: 'Sobre nosotros - Imagen 1',
			rounded: 'large',
		},
		{
			src: '/img/proposito/proposito2.png',
			alt: 'Sobre nosotros - Imagen 2',
			rounded: 'default',
		},
		{
			src: '/img/proposito/proposito3.png',
			alt: 'Sobre nosotros - Imagen 3',
			rounded: 'default',
		},
		{
			src: '/img/proposito/proposito4.png',
			alt: 'Sobre nosotros - Imagen 4',
			rounded: 'default',
		},
		{
			src: '/img/proposito/proposito5.png',
			alt: 'Sobre nosotros - Imagen 5',
			rounded: 'default',
		},
	]

	return (
		<section className="relative bg-white pt-[64px] pb-[48px] md:pt-[96px] md:pb-[96px]">
			{/* Content with padding */}
			<div className="mx-auto max-w-[1400px] px-[37.5px] md:px-[120px]">
				{/* Tag */}
				<div className="mb-[56px] md:mb-[64px]">
					<Tag
						size="l"
						corner="rounded"
						variant="secondary"
						color="green"
						appearance="solid"
						leftIcon="healtcare"
						option="text-icon-left"
					>
						Sobre nosotros
					</Tag>
				</div>

				{/* Content - 2 columns layout */}
				<div className="mb-[40px] grid items-start gap-16 md:mb-[64px] md:grid-cols-2 md:gap-10">
					<h2 className="text-[32px] leading-[45px] font-medium text-blue-800 md:text-[56px] md:leading-[70px]">
						¿Quiénes
						<br />
						somos?
					</h2>

					<div className="space-y-5">
						<p className="text-body-lg text-neutral-800">
							100prevalor combina seguridad, tecnología y sustentabilidad para
							ofrecer seguros y servicios que protegen lo que más valoran sus
							clientes. Nuestro modelo de negocio destina un porcentaje de cada
							servicio a proyectos ambientales y sociales.
						</p>
						<p className="text-body-lg text-neutral-800">
							Nuestra historia comenzó en 2010 con el objetivo de generar un
							impacto positivo en la comunidad a través de la inclusión laboral
							de personas con discapacidad.
						</p>
					</div>
				</div>
			</div>

			{/* Carousel - full width, centered */}
			<div className="flex justify-center overflow-hidden">
				<Carousel images={carouselImages} showControls={true} />
			</div>
		</section>
	)
}
